export default __webpack_public_path__ + "a0d2b7fcd21963e9e003e240ad1aa34d.png";